<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 12:02:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-16 17:51:35
 * @FilePath: \zhucai_user\src\pages\member\child\info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">修改密码</div>
    <div class="my-content">
      <div class="statusBox">
        <div class="active">
          <img src="@/assets/img/member/33.png" alt="" class="img" />
          <p class="active">身份认证</p>
        </div>
        <div class="dian">
          <div class="dian1"></div>
          <div class="dian2"></div>
          <div class="dian3"></div>
        </div>
        <div>
          <img
            :src="
              active == 1
                ? require('@/assets/img/member/34.png')
                : require('@/assets/img/member/36.png')
            "
            alt=""
            class="img"
          />
          <p :class="active > 0 ? 'active' : ''">设置操作</p>
        </div>
        <div class="dian">
          <div class="dian1"></div>
          <div class="dian2"></div>
          <div class="dian3"></div>
        </div>
        <div>
          <img src="@/assets/img/member/35.png" alt="" class="img" />
          <p :class="active == 2 ? 'active' : ''">完成</p>
        </div>
      </div>

      <el-form
        ref="form"
        :model="user"
        :rules="rules"
        label-width="0px"
        class="sub-form"
      >
        <div>
          <p class="title">{{ active == 0 ? "手机号验证" : "设置密码" }}</p>
          <p class="phone">当前手机号：{{ userInfo.Phone }}</p>
        </div>
        <el-form-item prop="dXCode" v-if="active == 0">
          <div class="dXCode">
            <el-input
              placeholder="请输入验证码"
              maxlength="10"
              v-model="user.dXCode"
            >
            </el-input>
            <div class="code">
              <p @click="handleCode" v-if="time1 == 60" style="">
                获取短信验证码
              </p>

              <p
                v-else
                style="
                  height: 100%;
                  border: 0;
                  width: 100%;
                  border-radius: 5px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ time1 }}s 后获取
              </p>
            </div>
            <!-- <identify
              ref="identify"
              :height="49"
              :width="160"
              style="border-radius: 4px; overflow: hidden"
            /> -->
          </div>
        </el-form-item>
        <div v-if="active == 1">
          <el-form-item label="" prop="oldPassword">
            <el-input
              v-model="user.oldPassword"
              placeholder="请输入旧密码"
              type="password"
              show-password
            />
          </el-form-item>
          <el-form-item label="" prop="newPassword">
            <el-input
              v-model="user.newPassword"
              placeholder="请设置新的密码"
              type="password"
              show-password
            />
          </el-form-item>
          <el-form-item label="" prop="confirmPassword">
            <el-input
              v-model="user.confirmPassword"
              placeholder="请再次输入您设置的新密码"
              type="password"
              show-password
            />
          </el-form-item>
        </div>
        <el-form-item>
          <el-button v-if="active == 0" @click="submit" class="submit-btn"
            >提交认证</el-button
          >
          <el-button v-if="active == 1" @click="submit2" class="submit-btn"
            >提交操作</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getToken, setToken, removeToken } from "@/util/auth";
import { SendSMS } from "@/api/common";
import { GetUserInfo, CheckSMS, ChangePassword } from "@/api/member";
/* eslint-disable */
export default {
  name: "account",
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassword !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      userInfo: {
        Phone: "",
      },
      code: "",
      active: 0,
      timer: null,
      time1: 60,
      user: {
        dXCode: undefined,
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
      },
      // 表单校验
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          {
            min: 5,
            max: 20,
            message: "长度在 5 到 20 个字符",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      GetUserInfo().then((res) => {
        // res.data.Avatar = this.webUrl + data.Avatar;
        this.$store.state.userInfo = {
          ...this.$store.state.userInfo,
          ...res.data,
        };
        this.userInfo = this.$store.state.userInfo;
      });
    },
    handleCode() {
      SendSMS({ TypeID: 4 })
        .then((res) => {
          if (res.code === 0) {
            this.$message({ message: "发送成功", type: "success" });
            this.daojishi();
            this.code = res.data;
          } else {
            // this.$message({ message: res.msg, type: "warning" });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    daojishi() {
      this.timer = setInterval(() => {
        if (this.time1 <= 0) {
          this.time1 = 60;
          clearInterval(this.timer);
        } else {
          this.time1 = Number(this.time1) - 1;
        }
      }, 1000);
    },
    submit() {
      CheckSMS({
        PhoneCode: this.user.dXCode,
      }).then((res) => {
        if (res.code == 0) {
          this.active = 1;
        } else {
          this.active = 0;
        }
      });
      // if (this.user.dXCode == this.code) {
      //   this.active = 1;
      // } else {
      //   this.$message({ message: "验证码错误", type: "warning" });
      //   this.active = 0;
      // }
    },
    submit2() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = {
            OldPassword: this.user.oldPassword,
            NewPassword: this.user.newPassword,
            ConfirmNewPassword: this.user.confirmPassword,
          };
          if(data.OldPassword == data.NewPassword){
            this.$message.error('新密码不能与旧密码相同');
            return;
          }
          ChangePassword(data).then((res) => {
            if (res.code !== 0) {
              return;
            }
            this.$message.success("修改成功!");
            setTimeout(() => {
              this.$store.state.userInfo = {};
            location.replace(location.pathname);
            localStorage.removeItem("ShareAuthKey");
            removeToken("Token");
            }, 2000);
          
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-container {
  height: 661px;
  .my-title {
    font-size: 18px;
    color: #333333;
    padding: 0 25px;
    height: 68px;
    line-height: 68px;
    background: #ffffff;
    border-radius: 10px;
  }
  .my-content {
    padding: 25px;
    margin-top: 1px;
    height: 810px;
    background: #ffffff;
    border-radius: 10px;
    .statusBox {
      margin-top: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 30px;
      .img {
        width: 104px;
        height: 116px;
      }
      p {
        margin-top: 20px;
        text-align: center;
        font-size: 20px;
        color: #999999;
      }
      .active {
        color: #1d79ff;
      }
    }
    .dian {
      display: flex;
      margin-bottom: 50px;
      gap: 5px;
      .dian1 {
        width: 10px;
        height: 10px;
        background: #1d79ff;
        border-radius: 50%;
        opacity: 0.2;
      }
      .dian2 {
        width: 10px;
        height: 10px;
        background: #1d79ff;
        border-radius: 50%;
        opacity: 0.6;
      }
      .dian3 {
        width: 10px;
        height: 10px;
        background: #1d79ff;
        border-radius: 50%;
      }
    }
  }
}
.sub-form {
  width: 470px;
  margin: 80px auto;
  .title {
    font-size: 24px;
    color: #333333;
  }
  .phone {
    font-size: 18px;
    color: #333333;
    margin: 10px 0;
  }
}
.submit-btn {
  width: 150px;
  margin-left: 168px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}
::v-deep .el-input__inner {
  width: 470px;
  height: 46px;
}
.dXCode {
  position: relative;
  &::after {
    width: 1px;
    height: 16px;
    content: "";
    background: #999999;
    position: absolute;
    right: 130px;
    top: 14px;
  }
  .code {
    width: 131px;
    text-align: right;
    position: absolute;
    right: 10px;
    bottom: 3px;
    color: #1d79ff;
    cursor: pointer;
  }
}
</style>
